import { RouteType } from '@/lib/route';
import Module from '.';

export interface ElearningParamType {
  elearningId: string;
  frameId?: string;
}

const ModuleRoutes: RouteType = {
  path: '/module/:elearningId/slide/:frameId?',
  component: Module,
};

export const ModuleSetupRoutes: RouteType = {
  path: '/module/:elearningId/setup',
  component: Module,
};

export const ModuleResourcesRoutes: RouteType = {
  path: '/module/:elearningId/resources',
  component: Module,
};

export const ModuleSlideRoutes: RouteType = {
  path: '/module/:elearningId/slide/:frameId?',
  component: Module,
};

export default ModuleRoutes;
